<template>
  <div class="register-page">
    <!-- Back to Home -->
    <router-link to="/" class="back-home">
      <i class="fas fa-arrow-left"></i>
      <span>返回首页</span>
    </router-link>

    <!-- Left promotional area -->
    <div class="promo-section">
      <div class="promo-content">
        <div class="brand">
          <div class="brand-icon">
            <i class="fas fa-calculator"></i>
          </div>
          <h1>高中数学组卷系统</h1>
        </div>

        <p class="tagline">智能组卷，高效教学</p>

        <div class="features">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-database"></i>
            </div>
            <div class="feature-text">
              <h3>海量题库</h3>
              <p>涵盖高中数学全部知识点，精选历年真题</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-magic"></i>
            </div>
            <div class="feature-text">
              <h3>智能筛选</h3>
              <p>按题型、难度、年份、地区精准筛选</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <div class="feature-text">
              <h3>一键组卷</h3>
              <p>快速生成 Word 试卷，支持自定义排版</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-users"></i>
            </div>
            <div class="feature-text">
              <h3>师生共用</h3>
              <p>教师组卷、学生刷题，一站式服务</p>
            </div>
          </div>
        </div>

        <div class="stats">
          <div class="stat-item">
            <span class="stat-num">10000+</span>
            <span class="stat-label">精选试题</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">500+</span>
            <span class="stat-label">知识点</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">100+</span>
            <span class="stat-label">学校使用</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right register form area -->
    <div class="form-section">
      <div class="form-container">
        <div class="form-header">
          <h2>创建账号</h2>
          <p>注册后即可开始您的提分之旅</p>
        </div>

        <Form :model="form" :rules="rules" ref="registerForm" class="register-form">
          <FormItem prop="username">
            <div class="input-group">
              <i class="fas fa-user"></i>
              <Input v-model="form.username" placeholder="请输入用户名" size="large" />
            </div>
          </FormItem>

          <div class="form-row two-cols">
            <FormItem prop="password">
              <div class="input-group">
                <i class="fas fa-lock"></i>
                <Input type="password" v-model="form.password" placeholder="设置密码" size="large" />
              </div>
            </FormItem>
            <FormItem prop="confirmPassword">
              <div class="input-group">
                <i class="fas fa-lock"></i>
                <Input type="password" v-model="form.confirmPassword" placeholder="确认密码" size="large" />
              </div>
            </FormItem>
          </div>

          <FormItem prop="role">
            <div class="role-selector">
              <div class="role-option" :class="{ active: form.role === 'teacher' }" @click="form.role = 'teacher'">
                <i class="fas fa-chalkboard-teacher"></i>
                <span>我是教师</span>
              </div>
              <div class="role-option" :class="{ active: form.role === 'student' }" @click="form.role = 'student'">
                <i class="fas fa-user-graduate"></i>
                <span>我是学生</span>
              </div>
            </div>
          </FormItem>

          <div class="form-row two-cols">
            <FormItem>
              <div class="input-group">
                <i class="fas fa-school"></i>
                <Input v-model="form.school" placeholder="所在学校（选填）" size="large" />
              </div>
            </FormItem>
            <FormItem>
              <div class="input-group">
                <i class="fas fa-graduation-cap"></i>
                <Input v-model="form.grade" placeholder="所在年级（选填）" size="large" />
              </div>
            </FormItem>
          </div>

          <FormItem prop="invite_code">
            <div class="input-group">
              <i class="fas fa-ticket-alt"></i>
              <Input v-model="form.invite_code" placeholder="邀请码（选填，注册即领100积分）" size="large" />
            </div>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="handleRegister" long size="large" :loading="loading" class="register-btn">
              <i class="fas fa-user-plus" v-if="!loading"></i>
              立即注册
            </Button>
          </FormItem>
        </Form>

        <div class="form-footer">
          <p>已有账号？<a @click="goToLogin">立即登录</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api, { setAuthToken, setUser } from '@/utils/api';

export default {
  name: "Register",
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: "",
        password: "",
        confirmPassword: "",
        role: "teacher",
        school: "",
        subject: "",
        grade: "",
        invite_code: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, message: "用户名至少3个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码至少6个字符", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
        role: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
      loading: false,
    };
  },
  mounted() {
    if (this.$route.query.invite) {
      this.form.invite_code = this.$route.query.invite;
    }
  },
  methods: {
    async handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (!valid) {
          return;
        }

        this.loading = true;
        try {
          const response = await api.post("/api/register", {
            username: this.form.username,
            password: this.form.password,
            role: this.form.role,
            school: this.form.school,
            subject: this.form.subject,
            grade: this.form.grade,
            invite_code: this.form.invite_code,
          });

          const data = response.data;

          // Store token and user info (auto-login)
          setAuthToken(data.token);
          setUser(data.user);

          this.$Message.success("注册成功！已自动登录");
          this.$router.push("/");
        } catch (error) {
          console.error("Registration error:", error);
          if (error.response && error.response.data) {
            this.$Message.error(error.response.data.error || "注册失败");
          } else {
            this.$Message.error("注册出错");
          }
        } finally {
          this.loading = false;
        }
      });
    },
    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  background: #fff;
  position: relative;
}

.back-home {
  position: absolute;
  top: 30px;
  right: 40px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-weight: 500;
  transition: all 0.3s;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-home:hover {
  color: #667eea;
  background: #fff;
  transform: translateX(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Left promotional section */
.promo-section {
  flex: 1.2;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: white;
  position: relative;
  overflow: hidden;
}

.promo-section::before {
  content: '';
  position: absolute;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  background: radial-gradient(circle at center, rgba(102, 126, 234, 0.15) 0%, transparent 70%);
  animation: pulse 20s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1) translate(0, 0);
    opacity: 0.5;
  }

  50% {
    transform: scale(1.1) translate(2%, 2%);
    opacity: 0.8;
  }
}

.promo-content {
  position: relative;
  z-index: 1;
  max-width: 540px;
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.brand {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.brand-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.brand h1 {
  font-size: 38px;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.5px;
  background: linear-gradient(90deg, #fff 0%, #cbd5e1 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.tagline {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 56px;
  font-weight: 500;
}

.features {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 56px;
}

.feature-item {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  transition: transform 0.3s;
}

.feature-item:hover {
  transform: translateX(10px);
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5b4fc;
  font-size: 20px;
  flex-shrink: 0;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.feature-text h3 {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #f8fafc;
}

.feature-text p {
  margin: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

.stats {
  display: flex;
  gap: 48px;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-num {
  font-size: 32px;
  font-weight: 800;
  color: #a5b4fc;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

/* Right form section */
.form-section {
  flex: 1;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
}

.form-container {
  width: 100%;
  max-width: 480px;
  background: #fff;
  padding: 48px;
  border-radius: 24px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03);
  animation: slideIn 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.form-header {
  margin-bottom: 32px;
  text-align: center;
}

.form-header h2 {
  font-size: 32px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 12px 0;
  letter-spacing: -1px;
}

.form-header p {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

.register-form {
  margin-bottom: 24px;
}

.form-row {
  margin-bottom: 0px;
}

.form-row.two-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.input-group {
  position: relative;
}

.input-group i {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  z-index: 1;
  font-size: 18px;
}

.input-group :deep(.ivu-input) {
  padding-left: 48px;
  height: 50px;
  border-radius: 12px;
  border: 2px solid #f1f5f9;
  background: #f8fafc;
  font-size: 15px;
  transition: all 0.3s;
}

.input-group :deep(.ivu-input:focus) {
  border-color: #667eea;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

/* Role selector */
.role-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.role-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: #f8fafc;
  border: 2px solid #f1f5f9;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.role-option i {
  font-size: 28px;
  color: #94a3b8;
}

.role-option span {
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
}

.role-option:hover {
  border-color: #667eea;
  background: #fff;
}

.role-option.active {
  border-color: #667eea;
  background: #fff;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.08);
}

.role-option.active i {
  color: #667eea;
}

.role-option.active span {
  color: #1e293b;
}

.register-btn {
  height: 54px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  transition: all 0.3s;
}

.register-btn:hover {
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.4);
}

.form-footer {
  text-align: center;
}

.form-footer p {
  color: #64748b;
  font-size: 15px;
}

.form-footer a {
  color: #667eea;
  cursor: pointer;
  font-weight: 700;
  margin-left: 4px;
}

.form-footer a:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 1200px) {
  .promo-section {
    padding: 40px;
  }

  .form-section {
    padding: 40px;
  }
}

@media (max-width: 1024px) {
  .register-page {
    flex-direction: column;
  }

  .back-home {
    top: 20px;
    right: 20px;
  }

  .promo-section {
    flex: none;
    min-height: 400px;
    padding: 60px 40px;
  }

  .form-section {
    padding: 60px 20px;
  }

  .form-container {
    padding: 40px 30px;
  }

  .stats {
    gap: 32px;
  }
}

@media (max-width: 640px) {
  .promo-section {
    padding: 40px 24px;
  }

  .brand h1 {
    font-size: 30px;
  }

  .tagline {
    margin-bottom: 40px;
  }

  .features {
    display: none;
  }

  .stats {
    justify-content: space-between;
    gap: 20px;
  }

  .stat-num {
    font-size: 24px;
  }

  .form-row.two-cols {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
</style>
